import { DOCUMENT, inject } from '@angular/core';
import { NavigationError } from '@angular/router';

// Chrome, Firefox and Safari word the failure differently.
const CHUNK_LOAD_FAILED =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

const RELOADED_KEY = 'notaryx.staleBuildReload';
// A reload that fails again within this window is not a stale build.
const RETRY_WINDOW_MS = 10_000;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_LOAD_FAILED.test(error.message);
}

/**
 * A tab opened before a deploy still runs the old build, whose lazy chunks are gone from the
 * server. Load the target URL in full to pick up the new build. If that fails too, the chunk is
 * really missing: leave the error rather than reload in a loop.
 */
export function reloadOnStaleBuild(error: NavigationError): void {
  if (!isChunkLoadError(error.error)) return;
  const window = inject(DOCUMENT).defaultView;
  if (!window) return;
  try {
    const last = Number(window.sessionStorage.getItem(RELOADED_KEY));
    if (Date.now() - last < RETRY_WINDOW_MS) return;
    window.sessionStorage.setItem(RELOADED_KEY, String(Date.now()));
  } catch {
    // Without storage, reloading could loop; leave the error visible.
    return;
  }
  window.location.assign(error.url);
}
